import React, { useEffect, useState } from 'react'
import './settings.css'
import { useDispatch, useSelector } from 'react-redux'
import { toggleDarkMode, toggleFont, toggleSettings, toggleSideBar } from '../../state/settingsSlice'

const Settings = () => {
    const dispatch = useDispatch()
    const {settings,selectFont,sidebar,selectTheme} = useSelector((state)=>state.settings)
    const handleSettings = () =>{
        dispatch(toggleSettings(!settings))
    }

    const handleFontChange = (e) =>{
        const selectedFont = e.target.value
        dispatch(toggleFont(selectedFont))
    }

    const handleSidebarTheme = (val) =>{
        dispatch(toggleDarkMode(val))
    }

    const handleSidebar = () =>{
        dispatch(toggleSideBar(!sidebar))
    }

    const handleDarkMode = (val) =>{
        dispatch(toggleDarkMode(val))
    }
    

  return (
    <div className="settings">
        <div className="settings__overlay" onClick={handleSettings}></div>

        <div className="settings__container">
            <div className="settings__header">
                <h4 className="settings__title">Settings</h4>
            </div>

            <div className="settings__content">

                {/* TOGGLE BODY FONTS */}
                <div className="settings__font">
                    <h5 className="settings-title">Fonts</h5>
                    <div className="settings__font-item">
                        <input type="radio" name="font" id="font1" 
                        className="settings__font-input" 
                        value='"Poppins", sans-serif'
                        checked={selectFont === '"Poppins", sans-serif'}
                        onChange={handleFontChange}/>
                        <label htmlFor="font1" className="settings__font-label">
                            Poppins Sans-serif
                        </label>
                    </div>
                    <div className="settings__font-item">
                        <input type="radio" name="font" id="font1" 
                        className="settings__font-input" 
                        value='"Roboto", sans-serif'
                        checked={selectFont === '"Roboto", sans-serif'}
                        onChange={handleFontChange}/>
                        <label htmlFor="font1" className="settings__font-label">
                            Roboto Sans-serif
                        </label>
                    </div>
                    <div className="settings__font-item">
                        <input type="radio" name="font" id="font1" 
                        className="settings__font-input" 
                        value='"Montserrat", sans-serif'
                        checked={selectFont === '"Montserrat", sans-serif'}
                        onChange={handleFontChange}/>
                        <label htmlFor="font1" className="settings__font-label">
                            Montserrat google font
                        </label>
                    </div>
                </div>

                {/* TOGGLE SIDEBAR THEME && CLOSE */}
                <div className="settings__sidebar">
                    <h5 className="settings-title">
                        Sidebar
                    </h5>
                    <div className="settings__sidebar-theme">
                        <h4 className="settings__sidebar-theme_label">Sidebar Color:</h4>
                        <div className="settings__sidebar-theme_buttons">
                            <button className={`setings__sidebar-theme_btn 
                            ${selectTheme === 'light' && 'active'}`}
                            onClick={() => handleSidebarTheme('light')}>
                                <i class='bx bxs-sun'></i>
                            </button>
                            <button className={`setings__sidebar-theme_btn 
                            ${selectTheme === 'dark-sidebar' || selectTheme === 'dark' ? 'active' : ''}`}
                            onClick={() => handleSidebarTheme('dark-sidebar')}>
                                <i class='bx bxs-moon' ></i>
                            </button>
                        </div>
                    </div>

                    {/* CLOSE SIDEBAR */}
                    <div className="settings__sidebar-toggle">
                        <h4 className="settings__sidebar-theme_label">Close Sidebar:</h4>
                        <input type="checkbox" onClick={handleSidebar}
                        checked={!sidebar}
                        className='settings__sidebar-theme_input'/>
                    </div>

                </div>

                {/* TOGGLE DARK/LIGHT MODE */}
                <div className="settings__theme">
                    <h5 className="settings-title">Mode</h5>
                    <div className="settigs__theme-items">
                        <button onClick={()=>handleDarkMode('light')}
                        className={`settings__theme-btn 
                        ${selectTheme === 'light' || selectTheme === 'dark-sidebar' ? 'active' : ''}`}>
                            Light
                        </button>
                        <button onClick={()=>handleDarkMode('dark')}
                        className={`settings__theme-btn ${selectTheme === 'dark' && 'active'}`}>
                            Dark
                        </button>
                    </div>
                </div>

                {/* BODY THEME */}
                <div className="settings__theme">
                    <h5 className="settings-title">Skin</h5>
                    <div className="settigs__theme-skin">
                        <button onClick={()=>handleDarkMode('dark')}
                        className='dark'>
                            {
                                selectTheme === 'dark' && <i class='bx bx-cross' style={{color: 'GrayText'}}></i>
                            }
                        </button>
                        <button onClick={()=>handleDarkMode('light')}
                        className='light'>
                            {
                                selectTheme === 'light' && <i class='bx bx-cross' style={{color: '#000'}}></i>
                            }
                        </button>
                        <button onClick={()=>handleDarkMode('blue')}
                        className='blue'>
                            {
                                selectTheme === 'blue' && <i class='bx bx-cross' style={{color: '#fff'}}></i>
                            }
                        </button>
                        <button onClick={()=>handleDarkMode('dark-blue')}
                        className='dark-blue'>
                            {
                                selectTheme === 'dark-blue' && <i class='bx bx-cross' style={{color: '#fff'}}></i>
                            }
                        </button>
                        <button onClick={()=>handleDarkMode('green')}
                        className='green'>
                            {
                                selectTheme === 'green' && <i class='bx bx-cross' style={{color: '#fff'}}></i>
                            }
                        </button>
                        <button onClick={()=>handleDarkMode('pink')}
                        className='pink'>
                            {
                                selectTheme === 'pink' && <i class='bx bx-cross' style={{color: '#fff'}}></i>
                            }
                        </button>
                        <button onClick={()=>handleDarkMode('orange')}
                        className='orange'>
                            {
                                selectTheme === 'orange' && <i class='bx bx-cross' style={{color: '#fff'}}></i>
                            }
                        </button>
                    </div>
                </div>

            </div>
        </div>
    </div>
  )
}

export default Settings